import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Config } from '../model/service-config';

@Injectable()
export class ServiceConfigService {

  constructor(
    private http: HttpClient
  ) { }

  private servicesConfig: Config;

  public getServiceConfig(): Config {
    return this.servicesConfig;
  }

  public resetServiceConfig() {
    this.servicesConfig = undefined;
  }

  /*public getSyncronousConfig(clientId: number): Promise<Config> {
    return new Promise<Config>(resolve => {
      this.getConfig(clientId).take(1)
        .subscribe((config: Config) => {
          this.servicesConfig = config;
          resolve(config);
        });
    });
  }*/

  public setServiceConfig(config: Config) {
    this.servicesConfig = config;
  }

  public getConfig(clientId: number): Observable<Config> {
    if (clientId) {
      return this.http.get<Config>(`${environment.API_BASE}/Clients/GetClientConfigs`).pipe(first())
        .pipe(map((config: Config) => Config.toModel(JSON.stringify(config))));
    }
    return Observable.throw('No existe configuración para cliente indefinido');
  }

}
